import { t } from '@lingui/core/macro';
import { Plural, Trans } from '@lingui/react/macro';
import { Box, Button, LoaderOverlay, Menu } from '@pocketlaw/tetris';
import { Link } from 'react-router-dom';
import { DocumentAttachmentItem, DocumentAttachments } from 'shared/domains/documents';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { MetadataApprovers } from './MetadataApprovers';
import { MetadataEntry } from './MetadataEntry';
import { SelectLanguage } from './SelectLanguage';
import { useDraftPreview } from '../../DraftPreviewProvider';
import { Container } from './styled';
export function TemplateData() {
    const { estimatedTime, createDraft, category, composer, templates, approvers, loading } = useDraftPreview();
    const { attachments } = composer;
    const orcaEditorEnabled = useFeatureFlag('feature_orca_editor');
    const disabledText = t({
        message: 'Old template format, editing is not supported',
        comment: 'Composer dialog, if a template source is not HTML, and not supported for editing.',
    });
    return (<LoaderOverlay enabled={loading}>
      <Container>
        <Box flexDirection="column" gap="md">
          <Button $stretch onClick={createDraft} size="small">
            <Trans comment="Preview template - Create document from template label">Create document</Trans>
          </Button>
          {orcaEditorEnabled && (<Menu.Root target={<Button $stretch type="button" appearance="secondary" size="small" disabled={!composer.isCompanyComposer}>
                  <Trans comment="Composer preview - Edit template menu button">Edit template</Trans>
                </Button>}>
              {templates.map(({ id, name, latestVersion }) => (<Menu.Item key={id} disabled={!(latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.isHtml)} render={<Link to={`/templates/${id}/edit`}>
                      <Menu.ItemText primary={name} secondary={(latestVersion === null || latestVersion === void 0 ? void 0 : latestVersion.isHtml) === false ? disabledText : ''}/>
                    </Link>}/>))}
            </Menu.Root>)}
        </Box>
        <MetadataEntry label={t({
            comment: 'Preview template - Language label',
            message: 'Language',
        })} component={<SelectLanguage />}/>
        <MetadataEntry label={t({ comment: 'Preview template - Category label', message: 'Category' })} component={category.title}/>
        {estimatedTime !== undefined && (<MetadataEntry label={t({
                comment: 'Preview template - Estimated time label',
                message: 'Estimated time',
            })} component={<Plural value={estimatedTime} one="# minute" other="# minutes"/>}/>)}
        {approvers.length > 0 && (<MetadataEntry label={t({ comment: 'Preview template - Approvers label', message: 'Approvers' })} component={<MetadataApprovers />}/>)}
        {attachments.length > 0 && (<MetadataEntry label={t({ comment: 'Preview template - Attachments label', message: 'Attachments' })} component={<DocumentAttachments hideAdd attachments={attachments} render={(attachment) => <DocumentAttachmentItem key={attachment.id} attachment={attachment}/>}/>}/>)}
      </Container>
    </LoaderOverlay>);
}
